import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import map from 'lodash/map';
import range from 'lodash/range';

import RcTooltip from 'rc-tooltip';

const PresentationProgressBar = ({ slides, currentSlideIdx, totalSlides, onGoToSlideClick }) => (
  <div className="progress-bar">
    {
      map(range(totalSlides), (slideIdx) => (
        <RcTooltip 
          key={slideIdx}
          placement="top"
          popupClassName="presentation-tipsy"
          overlay={
            <div className="presentation-progress-tooltip">
              <img src={slides[slideIdx]} />
              <div>Slide { slideIdx + 1 }</div>
            </div>
          }
          mouseEnterDelay={0}
          mouseLeaveDelay={0}
        >
          <div
            style={{ width: `${(1 / totalSlides) * 100}%` }}
            onClick={() => {
              onGoToSlideClick(slideIdx);
            }}
            className={classNames('progress-step', {
              'is-first': slideIdx === 0,
              'is-last': slideIdx + 1 === totalSlides,
              'is-current': slideIdx === currentSlideIdx,
              active: currentSlideIdx >= slideIdx
            })}
          />
        </RcTooltip>
      ))
    }
  </div>
);

PresentationProgressBar.propTypes = {
  slides: PropTypes.array.isRequired,
  totalSlides: PropTypes.number.isRequired,
  currentSlideIdx: PropTypes.number.isRequired,
  onGoToSlideClick: PropTypes.func.isRequired
};

export default PresentationProgressBar;
